export const STATIC_CONTENT_KEYS = {
  MAIN_PAGE_BACKGROUND: 'MainPageBackgroundImageWeb',
};
